
export class KYMW0905InputModel {

  /**
   * 画面ＩＤ
   */
  public formId: string = <string>'';

  /**
   * 受注コード
   */
  public orderCode: string = <string>'';

  /**
   * Ｐコード
   */
  public pCode: string = <string>'';

  /**
   * アイテムコード
   */
  public itemCode: string = <string>'';

  /**
   * 商品案内用商品名
   */
  public guideGoodsName: string = <string>'';

  /**
   * 商品案内用規格名
   */
  public guideStandardName: string = <string>'';

  /**
   * 分析連番
   */
  public analysisSeqNo: string = <string>'';

  /**
   * 分析単位
   */
  public analysisUnit: string = <string>'';

  /**
   * 栄養成分備考
   */
  public nutritionalNote: string = <string>'';

  /**
   * 栄養成分リスト
   */
  public nutrientDetailList: Array<any> = null;

  /**
   * 編集モード
   * "I" : コンテキストメニュー「栄養成分新規登録」での呼び出し
   * "U" : コンテキストメニュー「栄養成分メンテナンス」での呼び出し
   */
  public editMode: string = <string>'';

  // 項番2231 START 障害管理No.U01954対応
  /**
   * 複数栄養成分フラグ
   */
  public multiFlag: boolean = <boolean>false;
  // 項番2231 END 障害管理No.U01954対応
}
